const { text, html, url, routes } = window;

export default (learnMoreLink) => `
<div class="iconContainer">
    <div class="checkBox"></div>
</div>
<span class="small-12 columns signUpSuccess-success primary-color">${ html('idcSignInSuccess.success') }</span>
<span class="small-12 columns signUpSuccess-startBorrowing">${ html('idcSignInSuccess.startBorrowing') }</span>
<span class="small-12 columns">${ text('idcSignInSuccess.whenYouComeBack', {useMobileNum: `<span class="bold">${ html('idcSignInSuccess.useMobileNum') }</span>`}) }</span>
<span class="small-12 columns">${ html('idcSignInSuccess.cardExperiation') } 
    ${learnMoreLink !== '' ? `<a class="signUpSuccess-learnMore secondary-color" href="${learnMoreLink}" target="_blank">${ html('idcSignInSuccess.learnMore') }</a>` : ``}
</span>
<span class="signUpSuccess-happyReading small-12 columns">${ html('idcSignInSuccess.happyReading') }</span>
<button class="small-12 columns secondary js-close button">${ html('idcSignInSuccess.browseCollection') }</button>
`;
